import { Component } from '@angular/core';

@Component({
  selector: 'jhi-insurance-policy',
  templateUrl: './insurance-policy.component.html',
})
export class InsurancePolicyComponent {}
